"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SearchResultTitle = exports.SearchResultAppLabel = exports.SearchResultText = exports.SearchResultContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var platform_1 = require("@hiyllo/ux/platform");
var styled_1 = require("@hiyllo/ux/styled");
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
exports.SearchResultContainer = (0, styled_1.styledRN)(react_native_1.Pressable, {
    backgroundColor: '#212021',
    padding: 15,
    borderRadius: 10,
    paddingRight: 30,
    position: 'relative',
    // @ts-expect-error ---
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    fontFamily: '"hiyllo", sans-serif'
});
exports.SearchResultText = (0, styled_1.styledRN)(react_native_1.Text, {
    color: 'white'
});
var SearchResultAppHeaderContainer = (0, styled_1.styledRN)(react_native_1.View, {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 5,
    position: 'absolute',
    bottom: 12.5,
    right: 12.5
});
var SearchResultAppHeaderText = (0, styled_1.styledRN)(react_native_1.Text, {
    color: 'white',
    fontSize: 10
});
exports.SearchResultAppLabel = react_1["default"].memo(function SearchResultAppHeader(props) {
    var FontAwesomeIcon = (0, platform_1.useFontAwesomeIcon)();
    return ((0, jsx_runtime_1.jsxs)(SearchResultAppHeaderContainer, { children: [(0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: props.icon, color: "white" }), (0, jsx_runtime_1.jsx)(SearchResultAppHeaderText, { children: props.title })] }));
});
exports.SearchResultTitle = (0, styled_1.styledRN)(react_native_1.Text, {
    // whiteSpace: "nowrap",
    // textOverflow: "ellipsis",
    color: "white",
    overflow: 'hidden',
    width: 0,
    flexGrow: 1,
    paddingRight: 40
});
